import { Flex } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";
import { generatePath, useNavigate } from "react-router";

import { AssetState, ModelCompact } from "__graphql__/types";
import { routes } from "config/routes";
import { NON_FUNCTIONAL_ASSET_STATES } from "flows/BatteryManagement/utils/constants";
import { BatteryIcon } from "ui/Icons/Icons";
import { BodyM } from "ui/Typography/Typography";

export function BatteryCard({
  state,
  model,
  batteryId,
  serialNumber,
}: {
  state: AssetState;
  model?: ModelCompact;
  batteryId: string;
  serialNumber: string;
}) {
  const navigate = useNavigate();
  const goToReportPage = () => {
    navigate(
      generatePath(routes.inventory.batteryManagement.report, {
        batteryId,
      }),
    );
  };
  return (
    <Flex
      as="button"
      onClick={goToReportPage}
      p="s200"
      direction="column"
      gap="s100"
      borderRadius="sm"
      bg="white"
    >
      <Flex gap="s200">
        <BatteryIcon boxSize="24px" />
        <BodyM noOfLines={1} wordBreak="break-all">
          <strong>{model?.name}</strong> {serialNumber}
        </BodyM>
      </Flex>
      {NON_FUNCTIONAL_ASSET_STATES.includes(state) && (
        <BodyM color="red.500" textAlign="left">
          <FormattedMessage id="pages.inventory.battery-management-page.cards.broken" />
        </BodyM>
      )}
    </Flex>
  );
}
